module.exports = __webpack_public_path__ + "static/media/partner-icon-catalyst-greyscale.f166d282.svg";